// HELLFIRE TINDER — Theme JS

document.addEventListener('DOMContentLoaded', () => {

  // ---- Mobile Menu ----
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => mobileNav.classList.add('open'));
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
  }

  // ---- Cart Count ----
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }
  updateCartCount();

// ---- Variant Selection + Price Update ----
  const variants = window.productVariants || [];
  const variantIdInput = document.getElementById('variant-id-input');
  const priceDisplay = document.getElementById('product-price-display');
  const comparePriceDisplay = document.getElementById('product-compare-price');
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const qtyInput = document.querySelector('.qty-input');

  if (!variants.length) return;

  // Detect available bundle tiers from variant titles (x1, x3, x5...)
  function getTierFromTitle(title) {
    // Matches: x3, x5, 3x, 5x, BUY 3, BUY3
    const match = title.match(/^x(\d+)|^(\d+)x|^buy\s*(\d+)/i);
    if (!match) return null;
    return parseInt(match[1] || match[2] || match[3]);
  }

  const availableTiers = [...new Set(
    variants.map(v => getTierFromTitle(v.title)).filter(t => t !== null)
  )].sort((a, b) => a - b);

  const isBundleProduct = availableTiers.length > 1;

  // Given a qty, return the best tier
  function bestTierForQty(qty) {
    let best = availableTiers[0];
    for (const tier of availableTiers) {
      if (qty >= tier) best = tier;
    }
    return best;
  }

  // Find variant matching a tier prefix
  function findVariantForTier(tier) {
    return variants.find(v => getTierFromTitle(v.title) === tier);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Update price display, hidden input, and button state from a variant
  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceDisplay) priceDisplay.textContent = formatMoney(variant.price);
    if (comparePriceDisplay) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceDisplay.textContent = formatMoney(variant.compare_at_price);
        comparePriceDisplay.style.display = 'inline';
      } else {
        comparePriceDisplay.style.display = 'none';
      }
    }
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  // Update which variant button appears active (display only)
  function highlightTierBtn(tier) {
    document.querySelectorAll('.variant-btn').forEach(btn => {
      const btnTier = getTierFromTitle(btn.dataset.value);
      btn.classList.toggle('selected', btnTier === tier);
    });
  }

  // Show a contextual note below the qty input
  let qtyNote = document.getElementById('qty-bundle-note');
  if (!qtyNote) {
    qtyNote = document.createElement('p');
    qtyNote.id = 'qty-bundle-note';
    qtyNote.style.cssText = 'font-size:12px;color:var(--ember);letter-spacing:0.05em;margin-top:6px;min-height:18px;font-family:var(--font-heading);text-transform:uppercase;';
    qtyInput && qtyInput.parentNode.insertAdjacentElement('afterend', qtyNote);
  }

  function updateFromQty(qty) {
    if (!isBundleProduct) return;
    const tier = bestTierForQty(qty);
    const variant = findVariantForTier(tier);
    applyVariant(variant);
    highlightTierBtn(tier);

    // Note messaging
    if (qty >= (availableTiers[availableTiers.length - 1])) {
      qtyNote.textContent = `Best deal — ${tier}-bag bundle applied`;
    } else if (tier > availableTiers[0]) {
      const nextTier = availableTiers[availableTiers.indexOf(tier) + 1];
      if (nextTier) {
        qtyNote.textContent = `${tier}-bag bundle applied — add ${nextTier - qty} more for the ${nextTier}-bag deal`;
      } else {
        qtyNote.textContent = `${tier}-bag bundle applied`;
      }
    } else {
      const nextTier = availableTiers[1];
      if (nextTier) {
        qtyNote.textContent = `Add ${nextTier - qty} more to unlock the ${nextTier}-bag bundle`;
      } else {
        qtyNote.textContent = '';
      }
    }
  }

  // If bundle product, wire buttons to qty and qty to variant
  document.querySelectorAll('.hide-qty-no-js').forEach(el => el.classList.remove('hide-qty-no-js'));

  if (isBundleProduct) {
    document.querySelectorAll('.variant-btn').forEach(btn => {
      const tier = getTierFromTitle(btn.dataset.value);
      if (tier === availableTiers[0]) btn.classList.add('selected');
      btn.addEventListener('click', () => {
        if (qtyInput) {
          qtyInput.value = tier;
          updateFromQty(tier);
        }
      });
    });

    // Drive everything from qty
    if (qtyInput) {
      const maxTier = availableTiers[availableTiers.length - 1];
      qtyInput.max = maxTier;

      function clampAndUpdate() {
        let qty = parseInt(qtyInput.value) || 1;
        if (qty > maxTier) {
          qty = maxTier;
          qtyInput.value = maxTier;
          qtyNote.textContent = `Max bundle is ${maxTier} — add to cart and repeat for larger orders`;
          const tier = bestTierForQty(qty);
          applyVariant(findVariantForTier(tier));
          highlightTierBtn(tier);
          return;
        }
        updateFromQty(qty);
      }

      qtyInput.addEventListener('input', clampAndUpdate);
      qtyInput.addEventListener('change', clampAndUpdate);
      updateFromQty(parseInt(qtyInput.value) || 1);
    }
  } else {
    // Non-bundle product — original variant button behavior
    let selectedOptions = {};
    document.querySelectorAll('.variant-btn.selected').forEach(btn => {
      selectedOptions[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
    });

    function findMatchingVariant() {
      return variants.find(v => v.options.every((opt, i) => selectedOptions[i] === opt));
    }

    function updateVariantUI() {
      const matched = findMatchingVariant();
      if (matched) applyVariant(matched);
    }

    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optionIndex = parseInt(btn.dataset.optionIndex);
        document.querySelectorAll(`.variant-btn[data-option-index="${optionIndex}"]`).forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedOptions[optionIndex] = btn.dataset.value;
        updateVariantUI();
      });
    });
  }

    // ---- Add to Cart (AJAX) ----
  const atcForm = document.querySelector('.add-to-cart-form-el');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = atcForm.querySelector('.add-to-cart-btn');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(atcForm);
      // Bundle products: qty input reflects tier selection, always add 1 unit
      if (isBundleProduct) formData.set('quantity', '1');
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (res.ok) {
          btn.textContent = 'Added!';
          await updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        } else {
          btn.textContent = 'Try Again';
          btn.disabled = false;
        }
      } catch (e) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  }

  // ---- Product Image Thumbnails ----
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('#main-product-image');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.src;
    });
  });

  // ---- Scroll-reveal ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .brand-content, .brand-logo-large').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

});